import React from "react";

import { Box, Row, StaticField } from "@intech/web-ui";

import { LoadingComponent } from "../../../../components/LoadingComponent";

interface IProps {
  saldo: any | null
}

export const SaldoBD: React.FC<IProps> = ({
  saldo
}) => {

  if (saldo !== null && saldo !== undefined) {
    return (
      <Box title={"Benefício"}>

        <Row form>
          <StaticField
            value={saldo.DS_PLANO}
            title={"Plano"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={saldo.COD_CNPB}
            title={"CNPB"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={saldo.DS_ESPECIE}
            title={"Espécie de Benefício"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={saldo.DT_INICIO_FUND}
            title={"Data de Início do Benefício"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Box>
          <div className={"text-center"}>
            O tempo previsto de exaurimento da sua renda é:
            <br />
            <span className={"text-primary"}>
              <StaticField
                value={"RENDA VITALÍCIA"}
                inline
              />
            </span>
          </div>
        </Box>
      </Box>
    )
  }

  return (
    <LoadingComponent />
  );
}